/**
 * <kk-footer> — marks the newsletter button busy (`aria-busy`) while the form submits, so the shared
 * in-button spinner shows instead of a busy cursor.
 */
if (!customElements.get('kk-footer')) {
  class KKFooter extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.addEventListener(
        'submit',
        (event) => event.target.querySelector?.('.kk-footer__submit')?.setAttribute('aria-busy', 'true'),
        { signal: this.abort.signal }
      );
    }

    disconnectedCallback() {
      this.abort?.abort();
    }
  }

  customElements.define('kk-footer', KKFooter);
}
